export enum ImportFileType {
    NAVAIDS_EAD_45 =  "NAVAIDS_EAD_45",
    NAVAIDS_EAD_51 = "NAVAIDS_EAD_51",
    NAVAIDS_XML = "NAVAIDS_XML",
    NAVAIDS_NM_AIXM51 = "NAVAIDS_NM_AIXM51",
    NAVAIDS_ARINC424 = "NAVAIDS_ARINC424",

    VERTEX_EAD_45_PHASE1 = "VERTEX_EAD_45_PHASE1",
    VERTEX_EAD_45_PHASE2 = "VERTEX_EAD_45_PHASE2",
    VERTEX_EAD_51_PHASE1 = "VERTEX_EAD_51_PHASE1",
    VERTEX_EAD_51_PHASE2 = "VERTEX_EAD_51_PHASE2",
    AERODROMES_EAD_45 = "AERODROMES_EAD_45",
    AERODROMES_EAD_51 = "AERODROMES_EAD_51",
    AERODROMES_NM_AIXM51 = "AERODROMES_NM_AIXM51",
    COORDINATE_POINTS_XML = "COORDINATE_POINTS_XML",
    COORDINATE_POINTS_EAD45 = "COORDINATE_POINTS_EAD45",
    COORDINATE_POINTS_NM_AIXM51 = "COORDINATE_POINTS_NM_AIXM51",
    COORDINATE_POINTS_ARINC424= "COORDINATE_POINTS_ARINC424",
    
    PROCEDURES_XML = "PROCEDURES_XML", 
    PROCEDURES_EAD_45_PHASE1 = "PROCEDURES_EAD_45_PHASE1", 
    PROCEDURES_EAD_45_PHASE2 = "PROCEDURES_EAD_45_PHASE2",
    PROCEDURES_EAD_51_PHASE1 = "PROCEDURES_EAD_51_PHASE1", 
    PROCEDURES_EAD_51_PHASE2 = "PROCEDURES_EAD_51_PHASE2",
    PROCEDURES_NM_AIXM51 = "PROCEDURES_NM_AIXM51",
    PROCEDURES_ARINC424 = "PROCEDURES_ARINC424",

    ROUTESEGMENTS_EAD45_PHASE1 = "ROUTESEGMENTS_EAD45_PHASE1", 
    ROUTESEGMENTS_EAD45_PHASE2 = "ROUTESEGMENTS_EAD45_PHASE2", 
    ROUTESEGMENTS_EAD51 = "ROUTESEGMENTS_EAD51",

    NAVAIDS_SAFIRE = "NAVAIDS_SAFIRE"
}